import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import Page from 'containers/page';
import PDFPreview from 'components/PDFPreview';
import Loader from 'components/Loader';
import { useBackend } from '../../../providers/BackendProvider';

const Preview = () => {
  const { auditService } = useBackend();
  const { id } = useParams<{ id: string }>();
  const [file, setFile] = useState<any>(null);
  useEffect(() => {
    const fetchAuditPreview = async (auditId: string) => {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const file = await auditService.downloadPreview(parseInt(auditId));
      setFile(file);
    };

    fetchAuditPreview(id);
  }, [id]);
  return (
    <Page title="Preview">
      {!file ? <Loader /> : <PDFPreview file={file} />}
    </Page>
  );
};

export default Preview;
